// extracted by mini-css-extract-plugin
export default {"logoDocProps":"styles_logoDocProps__IgO0X","docPropsItem":"styles_docPropsItem__t2uHL"};